import { AttributeSelectedColorfulOption } from '@/fo/api/magento';

import { WHITE_COLOR, YELLOW_COLOR } from '../constants';
import { Label } from '../types';

const getPriority = (color: string) => {
  if (color === YELLOW_COLOR) return 0;
  if (color === WHITE_COLOR) return 2;
  return 1;
};

const sortByColorPriority = (a: { color: string }, b: { color: string }) =>
  getPriority(a.color) - getPriority(b.color);

export const labelsMapper = (
  options: AttributeSelectedColorfulOption[],
  mindboxLabels: Label[]
): Label[] => {
  const magentoLabels = options
    .filter((option) => option.label)
    .filter((option) => option.label.trim())
    .map(({ label, color, value }) => ({
      name: label,
      color: color ? `#${color}` : WHITE_COLOR,
      value
    }))
    .sort(sortByColorPriority);

  return [...mindboxLabels, ...magentoLabels].slice(0, 3);
};
